{
	"title": "Forgot your password?",
	"subtitle": "Enter the email registered in your account.",
	"description": "We will send a link to reset your password",
	"labels": {
		"company": "Company",
		"email": "Email"
	},
	"fields": {
		"organization": {
			"placeholder": "Enter the company",
			"required": "The company is required"
		},
		"email": {
			"placeholder": "Enter your email",
			"required": "The email is required",
			"invalid": "Invalid email"
		}
	},
	"submit": "Send",
	"submitWait": "Resend in {{time}}",
	"back": "Back",
	"successModal": {
		"title": "Request sent!",
		"subtitle": "If the provided data is correct, we will send a reset link to the registered email.",
		"btnTitle": "Understood"
	}
}
